import Api from '.';

export function listFrenquecyTypes() {
  return Api.get(`/frequency-type`);
}

export function getFrenquecyTypeById(id) {
  return Api.get(`/frequency-type/${id}`);
}
